<template>
    <v-row no-gutters>
        <v-col cols="12" sm="10" offset-sm="1">
            <span class="headline">Meni</span>
            <bit-page :breadcrumbs="breadcrumbs"></bit-page>
            <v-row align="center" class="white mt-3 pa-3" no-gutters>
                <span class="title green--text text--darken-3">Meni</span>
                <v-col class="d-flex mb-3" cols="12">
                    <v-divider></v-divider>
                </v-col>

                <v-col cols="12" sm="6" class="px-2">
                    <v-text-field
                            v-model="menu.name"
                            dense
                            label="Naziv"
                            outlined
                            prepend-inner-icon="mdi-subdirectory-arrow-right"
                    ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" class="px-2">
                    <v-text-field
                            v-model="menu.position"
                            dense
                            label="Pozicija"
                            outlined
                            prepend-inner-icon="mdi-subdirectory-arrow-right"
                    ></v-text-field>
                </v-col>
                <v-col cols="12">
                    <v-divider></v-divider>
                </v-col>
                <v-col cols="12" class="mt-2">
                    <v-row justify="center">
                        <v-btn color="primary" tile depressed @click="save">Snimi</v-btn>
                    </v-row>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>

<script>
	import bitPage from "../../components/layout/page";
    import axios from 'axios'
    import config from '../../config'

	export default {
		components: {
			bitPage
		},
		head() {
			return {
				title: 'BitLab CMS'
			}
		},
		data: () => ({
			breadcrumbs: [
				{
					text: 'Meni',
					disabled: false,
					to: {name: 'meni'},
				},
				{
					text: 'Dodavanje novog menija',
					disabled: true
				},
			],
			headers: [
				{text: 'ID', value: 'id'},
				{text: 'Name', value: 'name'},
				{text: 'Code', value: 'code'},
				{text: 'Icon', value: 'icon'},
				{text: 'Option', value: 'option'}
			],
			items: [],
            menu: {
                name: null,
                position: null
            },
            categoryItems: []
		}),
        methods: {
		    save() {
                this.axios.post(`${config.apiUrl}/menu`, this.menu).then(res => {
                    this.$router.push({name: 'meni'})
                })
            }
        }
	}
</script>
